import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function CanvasCrazeGameInfo() {
  return (
    <div className="mx-auto p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Canvas Craze" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Canvas Craze</h1>
      <img
        src="/thumbnails/CanvasCraze.png"
        alt="Canvas Craze game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Canvas Craze</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Canvas Craze is a fast-paced, collaborative drawing game where players take turns creating and guessing drawings in real time. Use a variety of brushes, shapes, and colors to express your creativity or challenge your friends to guess what you're drawing before time runs out!
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Join a room with friends or other players, or create your own private room.</li>
          <li>Take turns drawing prompts while others try to guess what you're drawing.</li>
          <li>Use different brush sizes, shapes, and colors to make your drawings stand out.</li>
          <li>Earn points for correct guesses and creative artwork.</li>
          <li>Undo, clear, and shape tools help you refine your masterpiece.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Features</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Real-time multiplayer drawing and guessing</li>
          <li>Customizable brush sizes, shapes, and color palette</li>
          <li>Undo and clear actions for better control</li>
          <li>Filled and unfilled shapes, markers, and more</li>
          <li>Fun for all ages and skill levels</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Tips & Tricks</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Use the undo button to quickly fix mistakes without clearing the whole canvas.</li>
          <li>Try different brush sizes and shapes for more expressive drawings.</li>
          <li>Communicate with your team for better guessing and more fun!</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Canvas Craze</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Jump into Canvas Craze and unleash your creativity! Play for free with friends or other players—no download or registration required.
        </p>
        <PlayGameLink game="CanvasCraze" gameTitle="Canvas Craze" />
      </section>
    </div>
  );
}
